const ServiceData = {
  STitle: "You SaasLand wherever your business agency",
  Service: [
    {
      id: 1,
      shape: "icon_shape1.png",
      icon: "ti-panel",
      text: "Export Presets",
      description:
        "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
      btn: "Read More",
      bicon: "ti-arrow-right",
    },
    {
      id: 2,
      shape: "icon_shape2.png",
      icon: "ti-layout-grid2",
      text: "Grid and Guides",
      description:
        "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
      btn: "Read More",
      bicon: "ti-arrow-right",
    },
    {
      id: 3,
      shape: "icon_shape3.png",
      icon: "ti-gallery",
      text: "Prototyping",
      description:
        "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
      btn: "Read More",
      bicon: "ti-arrow-right",
    },
    {
      id: 4,
      shape: "icon_shape4.png",
      icon: "ti-fullscreen",
      text: "Pixel Precision",
      description:
        "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
      btn: "Read More",
      bicon: "ti-arrow-right",
    },
  ],
  agtext1: "Why I say old chap that is spiffing bodge, blag pardon.",
  agtext2: "Why I say old chap that is spiffing bodge, blag pardon.",
  agtext3: "Starkers dropped a clanger lurgy is cack excuse my French what.",
  pServiceTitle: "Our Services",
  pServiceDetails:
    "Why I say old chap that is, spiffing jolly good a load of old tosh spend a penny tosser arse over.!",
  PaymentService: [
    {
      id: 1,
      image: "icon4.png",
      title: "Safer",
      description: "Well at public scho cheeky bugger grub burke.",
    },
    {
      id: 2,
      image: "icon7.png",
      title: "Flexible",
      description: "Well at public scho cheeky bugger grub burke.",
    },
    {
      id: 3,
      image: "icon5.png",
      title: "Convinient",
      description: "Well at public scho cheeky bugger grub burke.",
    },
    {
      id: 4,
      image: "icon8.png",
      title: "Protected",
      description: "Well at public scho cheeky bugger grub burke.",
    },
    {
      id: 5,
      image: "icon6.png",
      title: "World wide",
      description: "Well at public scho cheeky bugger grub burke.",
    },
  ],
  HRService: [
    {
      id: "1",
      HRtitles: "Export Presets",
      HRdescription:
        "Bog cheeky bugger blow off only a quid grub he legged it porkies tosser young delinquent argy-bargy.",
      Hicon: "panel",
      rclass: "pr_70",
      iclass: "icon_one",
    },
    {
      id: "2",
      HRtitles: "Grid and Guides",
      HRdescription:
        "Bog cheeky bugger blow off only a quid grub he legged it porkies tosser young delinquent argy-bargy.",
      Hicon: "layout-grid2",
      rclass: "pl_50 pr_20",
      iclass: "icon_two",
    },
    {
      id: "3",
      HRtitles: "Pixel Precision",
      HRdescription:
        "Bog cheeky bugger blow off only a quid grub he legged it porkies tosser young delinquent argy-bargy.",
      Hicon: "fullscreen",
      rclass: "pl_70",
      iclass: "icon_three",
    },
    {
      id: "4",
      HRtitles: "Vector Editing",
      HRdescription:
        "Bog cheeky bugger blow off only a quid grub he legged it porkies tosser young delinquent argy-bargy.",
      Hicon: "vector",
      rclass: "pr_70",
      iclass: "icon_four",
    },
    {
      id: "5",
      HRtitles: "Cloud Service",
      HRdescription:
        "Bog cheeky bugger blow off only a quid grub he legged it porkies tosser young delinquent argy-bargy.",
      Hicon: "cloud-down",
      rclass: "pl_50 pr_20",
      iclass: "icon_five",
    },
    {
      id: "6",
      HRtitles: "Iterate at Speed",
      HRdescription:
        "Bog cheeky bugger blow off only a quid grub he legged it porkies tosser young delinquent argy-bargy.",
      Hicon: "bolt",
      rclass: "pl_70",
      iclass: "icon_six",
    },
  ],
  rpost: [
    {
      id: "01",
      image: "blog-grid/post_1.jpg",
      ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
      admin: "Admin",
      date: "March 1, 2019",
    },
    {
      id: "02",
      image: "blog-grid/post_2.jpg",
      ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
      admin: "Admin",
      date: "March 10, 2019",
    },
    {
      id: "03",
      image: "blog-grid/post_3.jpg",
      ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
      admin: "Admin",
      date: "jan 10, 2019",
    },
    {
      id: "04",
      image: "blog-grid/post_4.jpg",
      ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
      admin: "Admin",
      date: "March 1, 2019",
    },
  ],

  // edit this line to generate new bloglist
  NewsList: [
    {
      id: "",
      image: "News/Perwira.jpg",
      btitle: "INTERNASIONAL SCIENCE and INVENTION FAIR (ISIF) 2024. AAL GET “2 GOLD MEDAL & NWERA SPECIAL AWARD",
      bdescription:
        "Achievements were made again by Naval Academy cadets at the prestigious International Science And Invention Fair (ISIF) 2024 at BCCI, Denpasar Bali.A prestigious international event because it was attended by 973 teams from 24 countries in the world.ISIF (International Science and Invention Fair) and NSIF (National Science and Innovation Fair) are prestigious world competitions that bring together young researchers, innovators, and students from various countries to present their scientific findings, research, and innovative projects. The competitions are designed to promote creativity and critical thinking in science and technology, provide opportunities for participants to gain international recognition and expand their professional networks.",
      Month: "NOV",
      Year: "2024",
      Pagelink: "https://peloporwiratama.co.id/2024/11/10/internasional-science-and-invention-fair-isif-2024-aal-raih-2-gold-medal-nwera-special-award/",
    },
    {
      id: "",
      image: "News/Cilacap.png",
      btitle: "CILACAP WINS MEDAL AT INTERNATIONAL SCIENCE AND INVENTION FAIR (ISIF) IN 2024",
      bdescription:
        "Cilacap - ISIF (International Science you Invention Fair) 2024 took place at the Denpasar Industrial Training Center, Bali where Cilacap Regency passed 2 teams, namely SMA Negeri 2 Cilacap and SMA Negeri 1 Maos to the final round which was held in a hybrid manner, namely offline and online on October 30-31, 2024. The announcement and awarding of prizes was held on Tuesday, November 5, 2024. The team from SMA Negeri 2 Cilacap won the bronze medal and SMA Negeri 1 Maos won the silver medal.",
      Month: "NOV",
      Year: "2024",
      Pagelink: "https://cilacapkab.go.id/v3/cilacap-raih-medali-di-ajang-international-science-and-invention-fair-isif-tahun-2024/",
    },
    {
      id: "",
      image: "News/Iran.WebP",
      btitle: "Iranian students grab colorful medals in ISIF 2023",
      bdescription:
        "The competition was held in Bali, Indonesia, from November 7 to 11. Udayana University (Unud) collaborated with the Indonesian Young Scientist Association (IYSA) to hold the 2023 ISIF at the Widyasabha Auditorium, Unud Jimbaran Campus.",
      Month: "NOV",
      Year: "2023",
      Pagelink: "/PageNews6",
    },
    {
      id: "",
      image: "News/KolabUNUDdanIYSA.WebP",
      btitle: "ISIF 2023 Held in Collaboration with IYSA, Officially Closed",
      bdescription:
        "The 2023 International Science and Invention Fair (ISIF) activity held in collaboration with the Indonesian Young Scientist Association (IYSA) and Udayana University through the Office of International Affairs (KUI), was officially closed in a ceremony at the Widya Sabha Auditorium, Bukit Jimbaran Campus, Badung on Friday (11/10/2023).",
      Month: "NOV",
      Year: "2023",
      Pagelink: "/PageNews4",
    },
    {
      id: "",
      image: "News/JuriSaatMelakukanPenilaian.WebP",
      btitle: "Followed by 685 Teams from 28 Countries, Udayana University and IYSA Collaborate to Hold the 5th ISIF",
      bdescription:
        "Udayana University (UNUD) hosted four prestigious national and international events, namely the International Science and Invention Fair (ISIF), Invention and Innovation Fair (IIF), National Research Teacher Competition (NRTC), and International Research Teacher Competition (IRTC) 2023",
      Month: "NOV",
      Year: "2023",
      Pagelink: "/PageNews5",
    },
    {
      id: "",
      image: "News/AkuntansiUnila.WebP",
      btitle: "Unila Accounting Team Wins Gold at ISIF 2022",
      bdescription:
        "The 2022 Accounting Department Student Team made the University of Lampung (Unila) proud at the 2022 International Science and Invention Fair (ISIF) competition organized by the Indonesian Young Scientist Association (IYSA), November 1-5, 2022.",
      Month: "NOV",
      Year: "2022",
      Pagelink: "/PageNews2",
    },
    {
      id: "",
      image: "News/MahasiwaUnsoed.WebP",
      btitle: "FISIP Unsoed Student Team wins gold medal at ISIF 2022",
      bdescription:
        "The Student Team of the Faculty of Social and Political Sciences (FISIP) Universitas Jenderal Soedirman (Unsoed) Purwokerto, Banyumas Regency, Central Java, won a gold medal at the 2022 International Science and Invention Fair (ISIF).",
      Month: "NOV",
      Year: "2022",
      Pagelink: "/PageNews3",
    },
    {
      id: "",
      image: "blog-grid/2019.jpg",
      btitle:
        "27 Research Results of Balinese Students and Students Participate in ISIF International Event",
      bdescription:
        "This event was attended by participants from 11 countries to display the results of research or the work of students and students in the fields of science, technology, or the combination of the two.",
      Month: "JUN",
      Year: "2019",
      Pagelink: "/PageNews1",
    },
  ],

  // list detail news
  News1: [
    {
      id: "01",
      image: "blog-grid/2019.jpg",
      Author: "Admin",
      Title:
        "27 Research Results of Balinese Students and Students Participate in ISIF International Event",
      LinkNews:
        "https://bali.tribunnews.com/2019/06/22/27-hasil-penelitian-siswa-dan-mahasiswa-bali-ikut-ajang-internasional-isif",
      Year: "2019",
    },
  ],
  News2: [
    {
      id: "01",
      image: "News/AkuntansiUnila.WebP",
      Author: "Admin",
      Title: "Unila Accounting Team Wins Gold at ISIF 2022",
      LinkNews:
        "https://www.unila.ac.id/tim-akuntansi-unila-raih-emas-pada-isif-2022/",
      Year: "2022",
    },
  ],
  News3: [
    {
      id: "01",
      image: "News/MahasiwaUnsoed.WebP",
      Author: "",
      Title: "FISIP Unsoed Student Team wins gold medal at ISIF 2022",
      LinkNews:
        "https://jateng.antaranews.com/berita/470849/tim-mahasiswa-fisip-unsoed-raih-medali-emas-di-isif-2022",
      Year: "2022",
    },
  ],
  News4: [
    {
      id: "01",
      image: "News/KolabUNUDdanIYSA.WebP",
      Author: "",
      Title: "ISIF 2023 Held in Collaboration with IYSA, Officially Closed",
      LinkNews:
        "https://lenteraesai.id/2023/11/10/isif-2023-yang-diselenggarakan-atas-kolaborasi-unud-dengan-iysa-resmi-ditutup/",
      Year: "2023",
    },
  ],
  News5: [
    {
      id: "01",
      image: "News/JuriSaatMelakukanPenilaian.WebP",
      Author: "",
      Title: "Followed by 685 Teams from 28 Countries, Udayana University and IYSA Collaborate to Hold the 5th ISIF",
      LinkNews:
        "https://updatebali.com/diikuti-685-tim-dari-28-negara-universitas-udayana-dan-iysa-berkolaborasi-gelar-isif-ke-5/",
      Year: "2023",
    },
  ],
  News6: [
    {
      id: "01",
      image: "News/Iran.WebP",
      Author: "",
      Title: "Iranian students grab colorful medals in ISIF 2023",
      LinkNews:
        "https://www.tehrantimes.com/news/491326/Iranian-students-grab-colorful-medals-in-ISIF-2023",
      Year: "2023",
    },
  ],

  work: [
    {
      id: "01",
      icon: "ti-settings one",
      title: "Premium plugins",
      p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
    },
    {
      id: "02",
      icon: "ti-heart-broken two",
      title: "Premium plugins",
      p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
    },
    {
      id: "03",
      icon: "ti-target  three",
      title: "Live page builder",
      p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
    },
  ],
};
export default ServiceData;
